// client/src/coms/conversations/previewText.js
// One-line previews for conversation lists: message tokens become words instead of raw markup such as <sticker:12>.
const TOKEN_WORDS = { sticker: 'Sticker', sound: 'Sound', gif: 'GIF', image: 'Image', file: 'File', poll: 'Poll' };

export function previewText(input) {
  return (
    String(input || '')
      // Custom emoji (<:name:id>, <a:name:id>) keep their name.
      .replace(/<a?:(\w{1,40}):\d{1,24}>/g, ':$1:')
      // Known media tokens read as a word in brackets; unknown markup is dropped rather than shown raw.
      .replace(/<(\w+):[^<>\s]{1,40}>/g, (m, kind) => {
        const word = TOKEN_WORDS[String(kind).toLowerCase()];
        return word ? `[${word}]` : '';
      })
      .replace(/\s+/g, ' ')
      .trim()
  );
}
